module.exports = __webpack_public_path__ + "static/5-54c0d8ef1f07d507e4176750d3b63ae4.jpg";